import { styled } from '@mui/material';

export const Wrapper = styled('div')`
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 48px);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
`;

export const Description = styled('div')`
  font-size: 18px;
`;
